import React from 'react';
import clsx from 'clsx';

import styles from '../styles.module.scss';
import verificationStyles from './Verification.module.scss';
import {ArrowLong} from '../../../assets';
import captchaClassic from '../../../assets/img/captcha-classic.png';
import captchaNumeric from '../../../assets/img/captcha-numeric.png';
import captchaNumerical from '../../../assets/img/captcha-numerical.png';

export const VerificationCard = () => {
  return (
    <div className={verificationStyles.card}>
      <div className={styles.top}>
        <div className={clsx(styles.label, styles.moderation)}>
          <div className={clsx(styles.labelInner, styles.moderation)}>moderation</div>
        </div>
        <div className={styles.buttonForward}>
          <ArrowLong />
        </div>
      </div>

      <h4 className={styles.title}>Verification</h4>
      <p className={styles.subTitle}>
        Bots are prevented from accessing the server by using captcha verification. Themis has three
        types of captcha - numeric classic and image. Furthermore, there are indicators in
        verification that are triggered by divergent normal user behaviour.
      </p>
      <div className={verificationStyles.content}>
        <div className={verificationStyles.inputBlock}>
          <input className={verificationStyles.input} type="text" placeholder="No input" />
        </div>
        <div className={verificationStyles.image1}>
          <img src={captchaNumeric} alt="captcha" />
        </div>
        <div className={verificationStyles.image2}>
          <img src={captchaNumerical} alt="captcha" />
        </div>
        <div className={verificationStyles.image3}>
          <img src={captchaClassic} alt="captcha" />
        </div>

        <div className={clsx(verificationStyles.decor, verificationStyles.decor1)}>
          <div className={verificationStyles.elem}>5</div>
        </div>
        <div className={clsx(verificationStyles.decor, verificationStyles.decor2)}>
          <div className={verificationStyles.elem}>m</div>
        </div>
        <div className={clsx(verificationStyles.decor, verificationStyles.decor3)}>
          <div className={verificationStyles.elem}>9</div>
        </div>
        <div className={clsx(verificationStyles.decor, verificationStyles.decor4)}>
          <div className={verificationStyles.elem}>i</div>
        </div>
      </div>
    </div>
  );
};
